import React from 'react';
import Layout from "../components/App/Layout"
import SEO from "../components/App/SEO"
import NavbarStyleTwo from '../components/App/NavbarStyleTwo';
import PageBanner from '../components/Common/PageBanner';
import Footer from '../components/App/Footer';
import StartProjectWithUs from '../components/Common/StartProjectWithUs';

import ServicesImg1 from '../assets/images/predictive-artificial-intelligence/1.png'
import ServicesImg2 from '../assets/images/predictive-artificial-intelligence/2.png'
import ServicesImg3 from '../assets/images/predictive-artificial-intelligence/3.png'

const SingleServices = () => {
    return (
        <Layout>
            <SEO title="Predictive AI" description="Use Machine Learning to assess historical data, discover patterns, observe trends, and use that information for better decision making."/>

			<NavbarStyleTwo />

			<PageBanner 
                pageTitle="Predictive AI" 
            /> 

<div className="overview-area ptb-100">
                <div className="container">
                    <div className="overview-box">
                        
                    <div className="overview-content">
                            <div className="content right-content">
                                <span className="sub-title">Better Decisions. Better Outcomes.</span>
                                <h2>Demand Forecasting</h2>
                                <p>With a combination of predictive and prescriptive ML solutions, you can improve forecasting accuracy, enhance operational efficiency and boost revenue.</p>
                                <ul className="features-list">
                                    <li><span><i className='bx bx-check'></i> Inventory Forecasting</span></li>
                                    <li><span><i className='bx bx-check'></i> Production Planning</span></li>
                                    <li><span><i className='bx bx-check'></i> Workforce Planning</span></li>
                                

                                </ul>
                            </div>
                        </div>

                        <div className="overview-image">
                            <div className="image">
                                <img src={ServicesImg1} alt="image" />
                            </div>
                        </div>
                    </div>

                    <div className="overview-box">
                        <div className="overview-image">
                            <div className="image">
                                <img src={ServicesImg2} alt="image" />
                            </div>
                        </div>
                        
                        <div className="overview-content">
                            <div className="content right-content">
                                <span className="sub-title">Elevate Customer Experience</span>
                                <h2>Personalization & Recommendations </h2>
                                <p>Harness machine learning to develop memorable customer experiences across the entire user journey. Drive revenue and brand loyalty by catering to individual customer preferences.</p>
                                <ul className="features-list">
                                    <li><span><i className='bx bx-check'></i>Personalize Customer Journeys</span></li>
                                    <li><span><i className='bx bx-check'></i>Optimize Recommendations</span></li>
                                    <li><span><i className='bx bx-check'></i>Improve Targeting with Customer Segmentation</span></li>
                                    
                                
                                    

                                </ul>
                            </div>
                        </div>
                        <div className="overview-box">
                        
                        <div className="overview-content">
                                <div className="content right-content">
                                    <span className="sub-title">Detect & Diagnose Anomalies</span>
                                    <h2>Anomaly Detection</h2>
                                    <p>Automatically detect anomalies within your data and identify their root causes. Configure customized alerts and actions when anomalies are detected.</p>
                                    <ul className="features-list">
                                        <li><span><i className='bx bx-check'></i> Monitor Business Operations </span></li>
                                        <li><span><i className='bx bx-check'></i> Improve Product Quality </span></li>
                                        <li><span><i className='bx bx-check'></i> Improve Customer Experience</span></li>
                                    

                                    </ul>
                                </div>
                            </div>
    
                            <div className="overview-image">
                                <div className="image">
                                    <img src={ServicesImg3} alt="image" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="services-area bg-f9f9f9 pt-100 pb-70">
                <div className="container">
                    <div className="section-title">
                        <span className="sub-title">DISCOVER INSIGHTS. DRIVE GROWTH. </span>
                        <h2>Core Application Areas</h2>
                        <p>Here are a few areas where Predictive AI can be used to improve forecasting accuracy, drive operational efficiency and improve customer experience.</p>
                    </div>

                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-cog"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Manufacturing</h3>
                                <p>Efficient schedule planning, product defect detection, predictive maintenance, pilferage control & more.</p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-mobile"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>eCommerce</h3>
                                <p>Personalized product recommendations, custom-tailored promotions, smarter inventory planning & more.</p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-shopping-bag"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Retail</h3>
                                <p>Discover product/sku trends, forecast future demand, analyze shopper behavior, predict daily/hourly footfalls & more.</p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-money"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Accounting</h3>
                                <p>Identify fraudulent transactions, automate vendor credit scoring, project monthly/quarterly cash flows & more.</p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-tv"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Streaming Platforms</h3>
                                <p> Analyze user streaming patterns & deliver: personalized music/movie recommendations, curated playlists & more</p>
                            </div>
                        </div>

                        {/* <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-search-alt"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Digital Applications</h3>
                                <p>Make applications smarter and personalized with machine learning,  </p>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>


            

            <StartProjectWithUs />
			  
			<Footer />
		</Layout>
    )
}

export default SingleServices;